import { IconButton } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { prevent } from "lib/prevent"
import { navigate } from "lib/routes/navigate"
import Iconify from "minimals-template/components/Iconify"
import { RegimeDraftLockHide } from "routes/regime/regime-draft-locking/regime-draft-lock-hide"
import { useTreeItemIndex } from "routes/schedule/lib/useTreeItemIndex"

export function TailoredScheduleAccordionActions() {
    const { regimeId, isEditable, tailoredItem } = useBoundContext()
    const index = useTreeItemIndex()

    return (
        <If truthy={isEditable}>
            <RegimeDraftLockHide>
                <IconButton
                    aria-label="Tailor schedule"
                    color="primary"
                    size="small"
                    onClick={prevent(handleTailor)}
                    data-cy="tailored-tailor-schedule"
                >
                    <Iconify icon="mdi:pencil" />
                </IconButton>
            </RegimeDraftLockHide>
        </If>
    )

    function handleTailor() {
        const [group, key] = tailoredItem.locations[0].split("!")
        const location = index.retrieve(`${group}~${regimeId}!${key}`)
        navigate(`/app/schedules/${location.id}?editEx=true`)
    }
}
